/**
 * 帮助中心访问权限
 */
export const HELP_DOC_PAGE_UUID = '751aee12-a2d0-49ba-965d-d77a2df321ab'

/**
 * 帮助中心操作权限
 */
export const HELP_DOC_ACTION_UUID = 'c2c05699-aacc-403a-8eb0-7763a30f92ab'
